import { useRouter } from "next/router";




export interface CustomRouterOptions {
    preserveQuery: string[]; // Specify the names of the query parameters to preserve
}


const useCustomRouter = () => {
    const router = useRouter();


    const push = (href: string, routerOptions?: CustomRouterOptions) => {
        const url = new URL(href.includes("http") ? href : location.origin + href);

        if (routerOptions?.preserveQuery) {
            routerOptions.preserveQuery.forEach((param) => {
                const params = new URLSearchParams(location.search)
                const val = params.get(param);

                if (val !== null) {
                    url.searchParams.append(param, val);
                }
            });
        }

        let urlString = url.toString();

        router.push(urlString);
    };

    return { push };
}

export default useCustomRouter